import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "placeholder"]

  connect() {
    // 监听粘贴事件
    this.handlePaste = this.handlePaste.bind(this)
    window.addEventListener("paste", this.handlePaste)
  }

  disconnect() {
    window.removeEventListener("paste", this.handlePaste)
  }

  // 处理粘贴逻辑
  handlePaste(event) {
    const items = (event.clipboardData || event.originalEvent.clipboardData).items
    for (let index in items) {
      const item = items[index]
      if (item.kind === 'file' && item.type.includes('image')) {
        const blob = item.getAsFile()
        this.processFile(blob)
      }
    }
  }

  // 传统的点击上传也要支持预览
  handleSelect(event) {
    const file = event.target.files[0]
    if (file) {
      this.processFile(file)
    }
  }

  processFile(file) {
    // 1. 将文件同步到隐藏的 file_field
    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    this.inputTarget.files = dataTransfer.files

    // 2. 更新预览图
    const reader = new FileReader()
    reader.onload = (e) => {
      if (this.hasPreviewTarget) {
        this.previewTarget.src = e.target.result
        this.previewTarget.classList.remove("hidden")
      }
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.classList.add("hidden")
      }
    }
    reader.readAsDataURL(file)
  }
}
